/**
 * @file Login dropdown.
 */
import { gsap } from 'gsap';

/**
 * Login Dropdown component.
 */
const vLoginDropdown = () => {
	const login = document.querySelector('.v-login-dropdown');
	if (!login) {
		return;
	}

	const page    = document.querySelector('.full-body');
	const trigger = document.querySelector('.v-utility-nav__login-trigger');
	const wrap    = login.querySelector('.v-login-dropdown__wrap');
	const overlay = login.querySelector('.v-login-dropdown__overlay');
	const close   = login.querySelector('.v-login-dropdown__close');
	const label   = login.querySelector('.v-login-dropdown__overlay-label');
	const parents = login.querySelectorAll('.v-login-dropdown__list-item > .v-login-dropdown__link');
	const backBtn = login.querySelector('.v-login-dropdown__back-button');
	const logo    = login.querySelector('.v-login-dropdown__logo-link');

	let currentMenu = null;
	let isAnimating = false;
	let isOpen      = false;
	let adSeen      = false;

	const isSidebar = matchMedia('(max-width: 1350px)');
	const isTablet  = matchMedia('(max-width: 1024px)');
	const isMobile  = matchMedia('(max-width: 550px)');

	/**
	 * Open the menu.
	 */
	const openMenu = () => {
		if (isAnimating) {
			return;
		}

		if (!isTablet.matches) {
			return;
		}

		isAnimating = true;

		// a11y: update aria attributes
		if (trigger.getAttribute('aria-expanded') === 'false') {
			trigger.setAttribute('aria-expanded', true);
		}
		if (login.getAttribute('aria-hidden') === 'true') {
			login.setAttribute('aria-hidden', false);
		}

		login.style.display = 'block';
		// label.style.display = 'block';

		/**
		 * On complete animation.
		 */
		const onComplete = () => {
			login.classList.add('open');
			page.classList.add('login-open');
			login.removeAttribute('style');
			page.removeAttribute('style');
			wrap.removeAttribute('style');
			overlay.removeAttribute('style');
			isAnimating = false;
			isOpen      = true;
			const chatSection = document.querySelector('section.v-cisco-chat--visible-login');
			chatSection?.setAttribute('aria-hidden', 'false');
			login.focus();

			// set Segmint ad
			//setLoginsAd();
		};

		if (isMobile.matches) {
			gsap.timeline({
				onComplete,
				defaults: {
					duration: 0.4,
				},
			})
				.fromTo(wrap, { translateX: '-100%' }, {
					translateX: 0,
				})
				.to(overlay, {
					opacity: 0.85,
				}, '<');
		} else if (isSidebar.matches) {
			gsap.timeline({
				onComplete,
				defaults: {
					duration: 0.4,
				},
			})
				.fromTo(wrap, { translateX: '100%' }, {
					translateX: 0,
				})
				.to(overlay, {
					opacity: 0.85,
				}, '<');
		} else {
			gsap.timeline({
				onComplete,
				defaults: {
					duration: 0.4,
				},
			})
				.to(login, {
					translateY: 0,
				})
				.to(page, {
					paddingTop: 112,
				}, '<')
				.to(overlay, {
					opacity: 0.85,
				}, '<');
		}
	};

	/**
	 * Close the menu.
	 */
	const closeMenu = () => {

		if (isAnimating) {
			return;
		}
		isAnimating = true;

		// updateDropDown( getDropDown() );

		// a11y: update aria attributes
		if (trigger.getAttribute('aria-expanded') === 'true') {
			trigger.setAttribute('aria-expanded', false);
		}
		if (login.getAttribute('aria-hidden') === 'false') {
			login.setAttribute('aria-hidden', true);
		}

		label.style.display = 'none';

		/**
		 * On complete animation.
		 */
		const onComplete = () => {
			login.classList.remove('open');
			page.classList.remove('login-open');
			login.removeAttribute('style');
			page.removeAttribute('style');
			wrap.removeAttribute('style');
			overlay.removeAttribute('style');
			isAnimating = false;
			isOpen      = false;
			const chatSection = document.querySelector('section.v-cisco-chat--visible-login');
			chatSection?.setAttribute('aria-hidden', 'true');

			trigger.focus();
		};

		if (isMobile.matches) {
			gsap.timeline({
				onComplete,
				defaults: {
					duration: 0.4,
				},
			})
				.fromTo(wrap, { translateX: 0 }, {
					translateX: '-100%',
				})
				.to(overlay, {
					opacity: 0,
				}, '<');
		} else if (isSidebar.matches) {
			gsap.timeline({
				onComplete,
				defaults: {
					duration: 0.4,
				},
			})
				.fromTo(wrap, { translateX: 0 }, {
					translateX: '100%',
				})
				.to(overlay, {
					opacity: 0,
				}, '<');
		} else {
			gsap.timeline({
				onComplete,
				defaults: {
					duration: 0.4,
				},
			})
				.to(login, {
					translateY: '-100%',
				})
				.to(page, {
					paddingTop: 0,
				}, '<')
				.to(overlay, {
					opacity: 0,
				}, '<');
		}
	};

	/**
	 * Create ad iFrame.
	 */
	// const setLoginsAd = () => {
	// 	// return if seen
	// 	if (adSeen === true) {
	// 		return false;
	// 	}

	// 	if (document.querySelector('.v-login-dropdown__list-item--ad')) {
	// 		const parent = document.querySelector('.v-login-dropdown__list-item--ad');
	// 		const { src, wrap } = parent.dataset;
	// 		const wrapper = document.createElement('div');
	// 		const frame = document.createElement('iframe');
	// 		const classes = wrap.split(' ');

	// 		// loop classes from cms,
	// 		// add each to wrapper
	// 		[...classes].map((c) => { wrapper.classList.add(c); });

	// 		// add srd from cms
	// 		// to iframe el
	// 		frame.setAttribute('src', src);
	// 		frame.setAttribute('frameborder', 0);
	// 		frame.setAttribute('seamless', 'seamless');

	// 		// insert new elements
	// 		parent.insertAdjacentElement('afterbegin', wrapper);
	// 		wrapper.insertAdjacentElement('beforeend', frame);

	// 		// flag to prevent
	// 		// multiple ads
	// 		adSeen = true;
	// 	}
	// };

	trigger.addEventListener('click', openMenu);
	overlay.addEventListener('click', closeMenu);
	close.addEventListener('click', closeMenu);
	login.addEventListener('focusout', () => {
		if (!isOpen) {
			return;
		}

		setTimeout(() => {
			if (
				login.contains(document.activeElement)
				|| document.activeElement === login
			) {
				return;
			}
			closeMenu();
		}, 0);
	});

	/**
	 * Change Menu.
	 *
	 * @param {Event} e - Click event.
	 */
	const changeNav = (e) => {
		e.preventDefault();

		if (isAnimating) {
			return;
		}

		isAnimating = true;

		const link        = e.target;
		const menu        = link.nextElementSibling;
		const item        = link.parentNode;
		const parentMenu  = link.parentNode.parentNode;
		menu.classList.add('visible');
		menu.style.zIndex = 99;

		backBtn.setAttribute('aria-hidden', 'false');
		backBtn.setAttribute('tabindex', '0');
		backBtn.classList.add('visible');
		logo.setAttribute('aria-hidden', 'true');
		logo.setAttribute('tabindex', '-1');
		logo.classList.add('hidden');

		gsap.to(menu, {
			translateX: 0,
			duration:   0.4,
			onComplete: () => {
				[...parentMenu.children].filter((child) => child !== item).forEach((child) => {
					child.style.display = 'none';
				});

				link.style.display = 'none';
				item.setAttribute('tabindex', '-1');
				// set tabindex to -1 so it's not reachable by keyboard

				menu.focus();
				menu.classList.add('open');
				menu.removeAttribute('style');
				currentMenu = menu;
				isAnimating = false;
			},
		});
	};
	[...parents].forEach((p) => p.addEventListener('click', changeNav));

	/**
	 * Navigate back on back button click.
	 *
	 * @param {Event} e - Btn click event.
	 */
	const navBack = (e) => {
		e.preventDefault();

		if (!currentMenu) {
			return;
		}

		if (isAnimating) {
			return;
		}

		isAnimating = true;

		const link       = currentMenu.previousElementSibling;
		const menu       = currentMenu;
		const item       = currentMenu.parentNode;
		const parentMenu = currentMenu.parentNode.parentNode;

		if (parentMenu.classList.contains('v-login-dropdown__list')) {
			backBtn.setAttribute('aria-hidden', 'true');
			backBtn.setAttribute('tabindex', '-1');
			backBtn.classList.remove('visible');
			logo.setAttribute('aria-hidden', 'false');
			logo.setAttribute('tabindex', '0');
			logo.classList.remove('hidden');
		}

		[...parentMenu.children].filter((child) => child !== item).forEach((child) => {
			child.removeAttribute('style');
		});

		link.removeAttribute('style');
		item.removeAttribute('tabindex');
		link.focus();

		gsap.to(menu, {
			translateX: '100%',
			duration:   0.4,
			onComplete: () => {
				menu.classList.remove('open');
				menu.classList.remove('visible');
				menu.removeAttribute('style');
				currentMenu = parentMenu;
				isAnimating = false;
			},
		});
	};
	backBtn.addEventListener('click', navBack);
};

export default vLoginDropdown;
